<!-- Digital Twin Highway Infrastructure Platform Introduction -->
<template>
  <div class="dtwin-highway-intro">
    <div class="dtwin-highway-intro-wrapper">
      <header
        class="dtwin-highway-intro-hd"
        v-scroll-animate="{
          animation: 'fadeInUp',
        }"
      >
        Digital Twin Highway Infrastructure Platform
      </header>
      <article
        class="dtwin-highway-intro-bd"
        v-scroll-animate="{
          animation: 'fadeInUp',
          delay: 200,
        }"
      >
        The Digital Twin Platform builds upon the existing information
        architecture to create a comprehensive digital management system for the
        entire lifecycle of highways. By deeply integrating 3D digital
        technology with highway management operations, the platform focuses on
        developing innovative 3D applications for areas such as:
      </article>
      <footer class="dtwin-highway-intro-ft">
        <aside class="intro-ft-aside">
          <div
            class="ft-aside-item"
            :class="{ active: currentInfo.id == item.id }"
            v-for="item in lists"
            :key="item.id"
            @mouseover="currentInfo = item"
            @click="currentInfo = item"
          >
            {{ item.label }}
            <span class="line"></span>
          </div>
        </aside>
        <article class="intro-ft-main">
          <img :src="currentInfo.imgUrl" class="ft-main-img" alt="" />
        </article>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "Solution",
  components: {},
  data() {
    return {
      lists: [
        {
          id: 1,
          label: "Operation Monitoring　>",
          imgUrl: require("@/assets/images/dtwin/twin-highway-1.png"),
        },
        {
          id: 2,
          label: "Traffic Flow Situation　>",
          imgUrl: require("@/assets/images/dtwin/twin-highway-2.png"),
        },
        {
          id: 3,
          label: "Emergency Scenario Simulation　>",
          imgUrl: require("@/assets/images/dtwin/twin-highway-3.png"),
        },
        {
          id: 4,
          label: "Road Disease Management　>",
          imgUrl: require("@/assets/images/dtwin/twin-highway-4.png"),
        },
      ],
      currentInfo: null,
    };
  },
  computed: {},
  created() {
    this.currentInfo = this.lists[0];
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.dtwin-highway-intro {
  padding: 80px 0 0 0;
  background: #fff;
  .dtwin-highway-intro-wrapper {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 48px;
    border-bottom: 1px solid #dbdbdb;
  }

  .dtwin-highway-intro-hd {
    margin-bottom: 40px;
    font-weight: bold;
    font-size: 32px;
    color: #333;
    line-height: 24px;
    text-align: center;
    font-style: normal;
  }
  .dtwin-highway-intro-bd {
    margin-bottom: 40px;
    font-weight: 400;
    font-size: 18px;
    color: #1d1d1f;
    line-height: 32px;
    text-align: justify;
    font-style: normal;
  }
  .dtwin-highway-intro-ft {
    display: flex;
    padding: 0 75px;
    height: 320px;
    .intro-ft-aside {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-right: 28px;
    }
    .intro-ft-main {
      width: 700px;
    }
    .ft-main-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .ft-aside-item {
      position: relative;
      width: 100%;
      padding: 16px 0;
      color: #666;
      font-size: 18px;
      cursor: pointer;
      &.active {
        color: #005ab4;
        font-weight: bold;
      }
      .line {
        position: absolute;
        left: 0;
        bottom: 0;
        height: 1px;
        width: 230px;
        background: #dbdbdb;
      }
    }
  }
}
</style>
